module.exports = __webpack_public_path__ + "img/n1.fac8040b.png";